import { render, staticRenderFns } from "./GenerativeImage.vue?vue&type=template&id=1499cc8b&scoped=true"
import script from "./GenerativeImage.vue?vue&type=script&lang=js"
export * from "./GenerativeImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1499cc8b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1499cc8b')) {
      api.createRecord('1499cc8b', component.options)
    } else {
      api.reload('1499cc8b', component.options)
    }
    module.hot.accept("./GenerativeImage.vue?vue&type=template&id=1499cc8b&scoped=true", function () {
      api.rerender('1499cc8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/pages/GenerativeImage.vue"
export default component.exports